if (!customElements.get('starry-header-search')) {
    customElements.define(
        'starry-header-search',
        class starryHeaderSearch extends HTMLElement {
            constructor() {
                super()
            }
            searchTimer = null
            connectedCallback() {
                this.init()
            }
            init() {
                // 触发器事件注册
                this.querySelector('.starry_search_trigger').addEventListener('click', () => {
                    this.open()
                })

                const inputEle = this.querySelector('.starry_search_input')
                //  清空事件注册
                this.querySelector('.starry_search_clear').addEventListener('click', () => {
                    inputEle.value = ''
                    this.search()
                })

                //  输入事件注册
                inputEle.addEventListener('input', (e) => {
                    if (this.searchTimer) {
                        clearTimeout(this.searchTimer)
                        this.searchTimer = null
                    }
                    this.searchTimer = setTimeout(() => {
                        this.search()
                    }, 300)
                })

                // 关闭事件注册
                const dropdownEle = this.querySelector('.starry_search_dropdown')
                dropdownEle.addEventListener('click', (event) => {
                    if (event.target === dropdownEle) {
                        this.close()
                    }
                })

                const mobileHeaderEle = this.querySelector('.starry_search_mobile_header')
                mobileHeaderEle.querySelector('.back_arrow').addEventListener('click', (event) => {
                    this.close()
                })
                mobileHeaderEle.querySelector('.close_button').addEventListener('click', (event) => {
                    this.close()
                })
            }
            open() {
                this.querySelector('.starry_search_dropdown').setAttribute('data-active', true)
                document.documentElement.style.overflow = 'hidden'
            }
            close() {
                this.querySelector('.starry_search_dropdown').setAttribute('data-active', false)
                document.documentElement.style.overflow = 'auto'
            }
            search() {
                const searchContent = this.querySelector('.starry_search_input').value.trim()
                const recommendationTitleEle = this.querySelector('.starry_recommendation_title')
                const recommendationEle = this.querySelector('.starry_recommendation')
                const resultEle = this.querySelector('.starry_search_result')
                const emptyEle = this.querySelector('.starry_search_empty')
                if (searchContent) {
                    fetch(`${window.Shopify.routes.root}search/suggest.json?q=${searchContent}&resources[type]=product`)
                        .then((response) => response.json())
                        .then((res) => {
                            if (recommendationTitleEle) {
                                recommendationTitleEle.style.display = 'none'
                            }
                            if (recommendationEle) {
                                recommendationEle.style.display = 'none'
                            }
                            const products = res.resources?.results?.products || []
                            if (products.length) {
                                const productListEle = resultEle.querySelector('.starry_search_product_list')
                                let productListHtml = ''
                                products.forEach(product => {
                                    const productItemHtml = `
                    <div class="starry_search_product_item">
                      <a class="starry_search_product_image" href="${product.url}">
                        <img src="${product.image}?width=212&height=212" alt="${product.title}" width="100%" height="100%" loading="lazy">
                      </a>
                      <div class="starry_search_product_info">
                        <div class="starry_search_product_title text_ellipsis_2">${product.title}</div>
                      </div>
                    </div>
                  `
                                    productListHtml += productItemHtml
                                })
                                productListEle.innerHTML = productListHtml
                                const searchResultTitleEle = resultEle.querySelector('.starry_search_result_title')
                                const title = searchResultTitleEle.dataset.title || ''
                                searchResultTitleEle.innerHTML = title.replace('{0}', `"${searchContent}"`)
                                resultEle.querySelector('.starry_search_result_link').setAttribute('href', `/search?q=${searchContent}&resources[type]=product`)
                                emptyEle.style.display = 'none'
                                resultEle.style.display = 'flex'
                            } else {
                                resultEle.style.display = 'none'
                                const tips = emptyEle.dataset.tips || ''
                                emptyEle.innerHTML = tips.replace('{0}', `"${searchContent}"`)
                                emptyEle.style.display = 'block'
                            }
                        })
                } else {
                    emptyEle.style.display = 'none'
                    resultEle.style.display = 'none'
                    if (recommendationTitleEle) {
                        recommendationTitleEle.style.display = 'block'
                    }
                    if (recommendationEle) {
                        recommendationEle.style.display = 'flex'
                    }
                }
            }
        }
    )
}